<template>
    <SfFilters>
        <SfFilterList
            :title="t('discipline')"
            ais-menu-name="disciplines"
            :modal-data="getModalContent('disciplines')"
        />

        <SfFilterList
            :title="t('type')"
            ais-menu-name="types"
            :modal-data="getModalContent('type')"
        />

        <SfFilterList
            :title="t('applicant')"
            modal-name="filter_info_types"
            ais-menu-name="applicants"
            :modal-data="getModalContent('applicant')"
        />
    </SfFilters>
</template>

<script setup>
import modalContent from '~/constants/modals';
import SfFilters from '~/patterns/organisms/filters/filters.vue';
import SfFilterList from '~/patterns/molecules/filter-list/filter-list.vue';

const { t, locale } = useI18n({
    useScope: 'local'
});

const getModalContent = (key) => {
    return modalContent[locale.value][key];
};
</script>

<i18n lang="json">
{
    "nl": {
        "discipline": "Vakgebied",
        "type": "Type",
        "applicant": "Aanvrager"
    },
    "en": {
        "discipline": "Area of expertise",
        "type": "Type",
        "applicant": "Applicant"
    }
}
</i18n>
